import {startHome} from './home'
import { openProductDialog } from './products'
import {startArticle} from './article';
import {startAnimationObserve} from './animations'
import {startCategoryFilters} from './category'

function getHeaderHeight(){
    let header = document.querySelector('header#mainHeader nav.desktop')
    let mobileHeader = document.querySelector('header#mainHeader nav.mobile')

    let headerHeight = 0
    let headerPadding = 0


    if(getComputedStyle(mobileHeader).visibility == 'visible'){ // I am in mobile mode
        headerHeight = mobileHeader.offsetHeight
        headerPadding = parseFloat(getComputedStyle(mobileHeader).padding.replace('px'))
    }else{
        headerHeight = header.offsetHeight
        headerPadding = parseFloat(getComputedStyle(header).padding.replace('px'))
    }


    let root = document.querySelector(':root');
    root.style.setProperty('--header-height', (headerHeight+headerPadding)+'px');
}

getHeaderHeight()

document.addEventListener('resize',getHeaderHeight)

startHome()
startArticle();

startAnimationObserve();
startCategoryFilters();

window.openProductDialog = openProductDialog